import { createStore } from 'vuex'

declare let SessionStorage: any;
const USER = 'USER';
const EXAM = 'EXAM';

const store = createStore({
  state: {
    user: SessionStorage.get(USER) || {},
    exam: SessionStorage.get(EXAM) || {},
    typeList: [
      {
        title: "安全生产管理", value: 'TSJ_001', list: [
          {
            title: "一般类生产经营单位管理", value: 'C_TSJ_101', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "危化品经营单位管理", value: 'C_TSJ_107', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "危化品生产单位管理", value: 'C_TSJ_105', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "烟花爆竹经营单位管理", value: 'C_TSJ_108', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（黑色金属铸造）", value: 'C_TSJ_112', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（铝及铝合金制造与铸造）", value: 'C_TSJ_117', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（铝冶炼）", value: 'C_TSJ_115', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（镁及镁合金制造与铸造）", value: 'C_TSJ_119', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（铅、锌冶炼）", value: 'C_TSJ_114', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（铜及铜合金制造与铸造）", value: 'C_TSJ_116', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（炼铁）", value: 'C_TSJ_106', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（铜冶炼）", value: 'C_TSJ_113', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（锌及锌合金制造与铸造）", value: 'C_TSJ_118', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（有色金属[除铜,铝,铅,锌]）", value: 'C_TSJ_109', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "金属冶炼（炼钢）", value: 'C_TSJ_110', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
          {
            title: "电镀", value: 'C_TSJ_123', list: [
              { title: "负责人", value: 'TAD_001' },
              { title: "安全员", value: 'TAD_002' }
            ]
          },
        ]
      },
      {
        title: "特种作业", value: 'TSJ_003', list: [
          {
            title: "电工作业", value: 'TSJ_003_1', list: [
              { title: "低压电工作业", value: 'C_TSJ_301' },
              { title: "高压电工作业", value: 'C_TSJ_302' },
              { title: "防爆电气作业", value: 'C_TSJ_303' }
            ]
          },
          {
            title: "焊接与热切割作业", value: 'TSJ_003_2', list: [
              { title: "熔化焊接与热切割作业", value: 'C_TSJ_304' }
            ]
          },
          {
            title: "高处作业", value: 'TSJ_003_3', list: [
              { title: "高处安装维修拆除作业", value: 'C_TSJ_305' },
              { title: "登高架设作业", value: 'C_TSJ_306' }
            ]
          },
          {
            title: "制冷与空调作业", value: 'TSJ_003_4', list: [
              { title: "制冷与空调设备运行操作作业", value: 'C_TSJ_307' },
              { title: "制冷与空调设备安装修理作业", value: 'C_TSJ_308' }
            ]
          },
          {
            title: "危险化学品安全作业", value: 'TSJ_003_5', list: [
              { title: "聚合工艺作业", value: 'C_TSJ_310' },
              { title: "合成氨工艺作业", value: 'C_TSJ_311' },
              { title: "化工自动化控制仪表作业", value: 'C_TSJ_309' }
            ]
          }
        ]
      },
      {
        title: "特种设备作业", value: 'TSJ_004', list: [
          {
            title: "特种设备复审", value: 'C_TSJ_901', list: [
              { title: "锅炉水处理", value: 'TAD_050' },
              { title: "工业锅炉司炉", value: 'TAD_049' },
              { title: "移动式压力容器充装", value: 'TAD_065' },
              { title: "快开门式压力容器", value: 'TAD_058' },
              { title: "起重机司机", value: 'TAD_055' },
              { title: "起重机指挥", value: 'TAD_062' },
              { title: "叉车司机", value: 'TAD_051' },
              { title: "氧舱维护保养", value: 'TAD_203' },
              { title: "电站锅炉司炉", value: 'TAD_202' },
              { title: "观光车和观光列车司机", value: 'TAD_201' },
              { title: "气瓶充装", value: 'TAD_068' },
              { title: "特种设备安全管理", value: 'TAD_004' },
            ]
          },
        ]
      },
      {
        title: "职业卫生管理", value: 'TSJ_002', list: [
          {
            title: "职业卫生管理", value: 'C_TSJ_201', list: [
              { title: "主要负责人", value: 'TAD_001' },
              { title: "职业卫生管理员", value: 'TAD_003' }
            ]
          }
        ]
      },
      {
        title: "其它培训", value: 'TSJ_005', list: [
          {
            title: "危险化学品作业", value: 'C_TSJ_501', list: [
              { title: "操作员", value: 'C_TSJ_501' },
              { title: "化验员", value: 'C_TSJ_501' },
              { title: "采购员", value: 'C_TSJ_501' },
              { title: "仓管员", value: 'C_TSJ_501' }
            ]
          },
          {
            title: "高危企业班组长", value: 'C_TSJ_502', list: [
              { title: "化工(危化品)", value: 'C_TSJ_502' },
              { title: "高温熔融", value: 'C_TSJ_502' },
              { title: "涉爆粉尘", value: 'C_TSJ_502' },
              { title: "危化品使用", value: 'C_TSJ_502' },
            ]
          },
          {
            title: "危化品使用", value: 'C_TSJ_508', list: [
              { title: "班组长", value: 'C_TSJ_508' },
            ]
          },
          {
            title: "有限空间作业", value: 'C_TSJ_509', list: [
              { title: "作业人员", value: '999' },
              { title: "监护人员", value: '999' },
              { title: "安全管理人员", value: '999' },
              { title: "应急救援人员", value: '999' },
            ]
          },
          {
            title: "特种设备生产单位", value: 'C_TSJ_426', list: [
              { title: "质量安全员", value: 'TAD_061' },
              { title: "质量安全总监", value: 'TAD_060' },
            ]
          },
          {
            title: "化工（危化品）企业控制室作业", value: 'C_TSJ_511', list: [
              { title: "操作员", value: 'TAD_021' },
            ]
          }
        ]
      }
    ]
  },
  mutations: {
    setUser(state, user) {
      state.user = user
      SessionStorage.set(USER, user)
    },
    setExam(state, exam) {
      state.exam = exam
      SessionStorage.set(EXAM, exam)
    }
  },
  actions: {
  },
  modules: {
  }
})
export default store;
